import { merge } from 'rxjs/observable/merge';
import { zip } from 'rxjs/observable/zip';
import { mapTo } from 'rxjs/operators/mapTo';

const mergePartitions = () => ({
  gotoNextStep,
  doBillingAddressChangeMutation,
  stopProgress,
  doAddBothNewFullAddressesBillingAddressAddMutation,
  doAddBothNewFullAddressesShippingAddressAddMutation,
  doShippingAddAndBillingSyncMutation,
  doBillingAddressAddMutation,
  notChangeShippingAddress,
  doShippingAddressMutation,
  doBillingAddressSyncMutation,
  doShippingAddressAddMutation,
  otherJunk,
}) =>
  // Tear down the graph back to it's original structure so it always
  // emits exactly one result
  merge(
    gotoNextStep,
    merge(
      doBillingAddressChangeMutation,
      merge(
        stopProgress,
        merge(
          zip(
            doAddBothNewFullAddressesBillingAddressAddMutation,
            doAddBothNewFullAddressesShippingAddressAddMutation
          ),
          merge(
            doShippingAddAndBillingSyncMutation,
            merge(
              zip(
                merge(
                  doBillingAddressAddMutation,
                  merge(
                    doBillingAddressSyncMutation,
                    merge(
                      doShippingAddressAddMutation,
                      otherJunk.pipe(mapTo(null))
                    )
                  )
                ),
                merge(
                  doShippingAddressMutation,
                  notChangeShippingAddress.pipe(mapTo(null))
                )
              )
            )
          )
        )
      )
    )
  );

export default mergePartitions;
